import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SecurityService } from '@dworkflow/shared/services/security.service';
import { TenantService } from '@dworkflow/shared/services/tenant.service';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import * as pollingActions from '../../state/polling.actions';

@Injectable({
  providedIn: 'root',
})

// Guard fuer Routen, die nur von FachAdmins oder SysAdmins geoeffnet werden duerfen
export class CanActivateErstellerGuard {
  private securityService = inject(SecurityService);
  private tenantService = inject(TenantService);
  private store = inject(Store);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // ist notwendig, da bei Refresh der Routen, die mit diesem Guard per canActiavte abgesichert sind,
    // keine RouterNavigated Action vor dem Aufruf dieser Aktion dispatched wird.
    // Dies führt zu einem unendlichen Ladekringel.
    this.store.dispatch(pollingActions.pollCheckLogin());

    return this.securityService.getCurrentUser().pipe(
      map(user => {
        if (user.isSystemAdmin || user.isWorkflowAdministrator || user.isWorkflowErsteller) {
          return true;
        }

        this.tenantService.redirectForbidden();

        return false;
      })
    );
  }
}

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(CanActivateErstellerGuard).canActivate(next, state);
};
